import React from "react";
import Slider from "react-slick";
import { listCarousel } from "./carousel-data";
import "./slick-theme.css";
import "./slick.css";
import * as S from "./style";

function LoginScreenCarousel() {

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false,
    }

    return (
        <S.CarouselContainerStyled>
            <S.CarouselTitleStyled>NOSSAS SOLUÇÕES DE CRÉDITOS EDUCACIONAIS</S.CarouselTitleStyled>
            <S.SliderContainerStyled>
                <Slider {...settings}>
                    {listCarousel.map((item, id) => (
                        <S.CarouselCardStyled key={id}>
                            <a href={item.link} target="_blank">
                                <S.ImageStyled src={item.image} />
                            </a>
                        </S.CarouselCardStyled>
                    ))}
                </Slider>
            </S.SliderContainerStyled>
        </S.CarouselContainerStyled>
    )
}

export default LoginScreenCarousel;